/**
 * Module: home-hero
 * Handle home hero carousel functionality
 */

import Siema from 'siema';

var hero,
    initialized = false,
    slides_selector = '.js-home-hero-slides',
    slide_selector = '.story--hero',
    pages_selector = '.js-home-hero-pages',
    page_selector = '.js-home-hero-page',
    nav_selector = '.js-home-hero-nav',
    prev_selector = '.js-home-hero-prev',
    next_selector = '.js-home-hero-next',
    slide_count = $( slide_selector ).length,
    $pages;

function init() {
    if( 1 < slide_count ) {
        // Initialize hero depending in initial window size
        if( 768 > window.innerWidth ) {
            init_hero();
        }

        // Initialize or destroy the hero on window resize
        $(window).resize( function() {
            if( 768 > window.innerWidth ) {
                init_hero();
            } else {
                destroy_hero();
            }
        });
    }
}

function init_hero() {
    if( !initialized ) {
        $pages = $( page_selector );

        hero = new Siema({
            selector: slides_selector,
            onInit: function() {
                $pages.eq( this.currentSlide ).addClass('js-active');
            },
            onChange: function() {
                $pages.removeClass('js-active');
                $pages.eq( this.currentSlide ).addClass('js-active');
            }
        });

        // Initialize navigation
        $( prev_selector ).on('click', () => hero.prev() );
        $( next_selector ).on('click', () => hero.next() );
    }

    initialized = true;
}

function destroy_hero() {
    if( initialized ) {
        hero.destroy( true );

        // Remove navigation events
        $( prev_selector ).off();
        $( next_selector ).off();
    }

    initialized = false;
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
    init: init
};


// WEBPACK FOOTER //
// ./scripts/components/home.js